import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconUp = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconUp.dimensions.width} ${IconUp.dimensions.height}`}
      {...otherProps}
    >
      <Path
        d="M11.657 6.657 6 1 .343 6.657"
        stroke={color || Color.premiumBlack}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
      />
    </Svg>
  )
}

IconUp.dimensions = {
  width: 12,
  height: 8,
}

export default IconUp
